import React from "react"
import { Stack, Text } from "@chakra-ui/react"
import SettingsSection from "components/settings/SettingsSection"
import WalletPassCustomization from "components/WalletPass/WalletPassCustomization"
import WalletPassUpgradeAlert from "components/WalletPass/WalletPassUpgradeAlert"
import { DioboxEvent } from "sharedTypes"
import { eventWalletPassBuilderPath } from "utilities/routes"

type Props = {
  event: DioboxEvent
}

const WalletPass = ({ event }: Props) => (
  <Stack spacing={16}>
    <SettingsSection
      title="Wallet Pass"
      description={(
        <>
          <Text>
            Wallet passes are digital credentials stored in Apple Wallet on iPhone
            and Google Wallet on Android. They appear alongside QR code passes,
            payment cards, and IDs,
            work offline,
            and surface on the lock screen with a QR code for quick check-in.
          </Text>
          <Text>
            When guests confirm their attendance on Diobox, they can add a pass to their wallet.
            Once added, the pass appears automatically on their lock screen before the event,
            giving fast access to their QR code and key event details.
          </Text>
        </>
      )}
    >
      {!event.passBuilderEnabled && <WalletPassUpgradeAlert />}
    </SettingsSection>
    <SettingsSection
      title="Branding & Customization"
      description={(
        <>
          The Diobox Pass Builder lets you fully customize your Wallet Pass,
          including logos, banner images, text fields, and back-of-pass content.
          A unified editor supports both Apple and Google Wallet,
          so your passes stay consistent across all devices.
        </>
      )}
    >
      <WalletPassCustomization event={event} builderPath={eventWalletPassBuilderPath(event.id)} />
    </SettingsSection>
  </Stack>
)

export default WalletPass
